import fundaNowClient from '@/client/fundaNowClient'

export default {
  postMobileAuthUrl(redirectPage) {
    return fundaNowClient.call({
      url: '/kyc/mobile-auth/url/',
      method: 'POST',
      data: {
        redirect_page: redirectPage
      }
    })
  },
  postMobileAuthUrlResult() {
    return fundaNowClient.call({
      url: '/kyc/mobile-auth/result/',
      method: 'POST',
    })
  },
  postVerifyResidentRegistrationCertificate(data) {
    return fundaNowClient.call({
      url: 'kyc/verify-resident-registration-certificate/',
      method: 'POST',
      data: data
    })
  },
  postVerifyDriverLicense(data) {
    return fundaNowClient.call({
      url: 'kyc/verify-driver-license/',
      method: 'POST',
      data: data
    })
  },
  postCdd(_data) {
    return fundaNowClient.call({
      url: 'kyc/cdd/',
      method: 'POST',
      data: {
        'data': {
          _data
        }
      }
    })
  },
  postEdd(_data) {
    return fundaNowClient.call({
      url: 'kyc/edd/',
      method: 'POST',
      data: {
        'data': {
          _data
        }
      }
    })
  },
}
